var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "daily-withdraw-limit-container" },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "tab",
          "form-props": { labelPosition: "left" },
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleShowLog },
                      },
                      [_vm._v("操作记录")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "username",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.username,
                    uid: row.uid,
                    "vip-level": row.vip_level,
                  },
                }),
              ]
            },
          },
          {
            key: "colPayoutLimit",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.payout_limit)))]
            },
          },
          {
            key: "colUpdatedAt",
            fn: function ({ row }) {
              return [
                _vm._v(
                  _vm._s(
                    row.updated_at
                      ? new Date(row.updated_at).toLocaleString()
                      : "-"
                  )
                ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "danger-button",
                    attrs: { size: "small", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDelete(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-position": "right",
                size: "small",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员账号", prop: "username" } },
                        [
                          _vm.isEdit
                            ? _c("el-input", {
                                attrs: {
                                  placeholder: "请输入会员账号",
                                  disabled: _vm.isEdit,
                                },
                                model: {
                                  value: _vm.formData.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "username", $$v)
                                  },
                                  expression: "formData.username",
                                },
                              })
                            : _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: "3",
                                  placeholder:
                                    "请输入会员账号，多行请用换行分隔",
                                },
                                model: {
                                  value: _vm.formData.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "username", $$v)
                                  },
                                  expression: "formData.username",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "单日提款限额",
                            prop: "payout_limit",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "limit-input",
                            attrs: {
                              controls: false,
                              min: 0,
                              precision: 2,
                              placeholder: "请输入单日提款限额",
                            },
                            model: {
                              value: _vm.formData.payout_limit,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "payout_limit", $$v)
                              },
                              expression: "formData.payout_limit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "3",
                              placeholder: "请输入备注",
                            },
                            model: {
                              value: _vm.formData.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog",
          attrs: {
            title: "操作记录",
            visible: _vm.logDialogVisible,
            width: "1200px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
            closed: _vm.handleLogDialogClosed,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.logPagination.currentPage,
                      "page-sizes": [10, 20, 30, 50],
                      "page-size": _vm.logPagination.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.logPagination.total,
                    },
                    on: {
                      "size-change": _vm.handleLogSizeChange,
                      "current-change": _vm.handleLogCurrentChange,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "page-search" },
            [
              _c(
                "el-form",
                {
                  ref: "logSearchFormRef",
                  attrs: {
                    inline: true,
                    model: _vm.logSearchForm,
                    "label-position": "right",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "会员账号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入会员账号",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.logSearchForm.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.logSearchForm, "username", $$v)
                                  },
                                  expression: "logSearchForm.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "操作人" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入操作人",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.logSearchForm.last_operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.logSearchForm,
                                      "last_operator",
                                      $$v
                                    )
                                  },
                                  expression: "logSearchForm.last_operator",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "操作时间" } },
                            [
                              _c("DateTimeRangePicker", {
                                staticClass: "withdraw-limit-date-range",
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.logSearchForm.dateRange,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.logSearchForm,
                                      "dateRange",
                                      $$v
                                    )
                                  },
                                  expression: "logSearchForm.dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 3 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.handleLogSearch },
                            },
                            [_vm._v("筛选")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.handleLogReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "page-content",
              staticStyle: { padding: "20px 0 0" },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.logTableData,
                    size: "small",
                    border: "",
                    stripe: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "player_username",
                      label: "会员账号",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "operation",
                      label: "操作类型",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.operation === "add"
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v("添加"),
                                ])
                              : scope.row.operation === "update"
                              ? _c("el-tag", { attrs: { type: "primary" } }, [
                                  _vm._v("更新"),
                                ])
                              : scope.row.operation === "delete"
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v("删除"),
                                ])
                              : _c("el-tag", { attrs: { type: "info" } }, [
                                  _vm._v(_vm._s(scope.row.operation)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "before",
                      label: "变更前",
                      "min-width": "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "after",
                      label: "变更后",
                      "min-width": "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "username",
                      label: "操作人",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "created_at",
                      label: "操作时间",
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.created_at
                                    ? new Date(
                                        scope.row.created_at
                                      ).toLocaleString()
                                    : "-"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }